import { ReactNode } from 'react';

import { Typography, Divider, useTheme } from '@mui/material';

export interface SideModalTitleTitleProps {
  children: ReactNode;
  titleClassName?: string;
}

export const SideModalTitle = ({
  children,
  titleClassName,
}: SideModalTitleTitleProps) => {
  const theme = useTheme();
  return (
    <Typography
      className={titleClassName}
      variant="h2"
      sx={{
        fontWeight: 600,
        fontSize: '1.5rem',
        lineHeight: '24px',
        position: 'sticky',
        pt: 2,
        top: 0,
        backgroundColor: theme.palette.background.paper,
        textTransform: 'capitalize',
        zIndex: 2,

        '&.customVariant': {
          textTransform: 'none',
        },
      }}
    >
      {children}
      <Divider sx={{ my: 2 }} />
    </Typography>
  );
};
